<template lang="pug">
div
	img(
		alt='Tripmeister logo'
		src='../assets/logo.png'
	)
	.col-sm-12
		br
		br
		Promised(
			:promise='cityOptionsPromise'
		)
			template(v-slot:pending)
				p Loading...
			template(v-slot:rejected='error')
				p Error: {{ error.message }}
			template(v-slot='data')
				v-select(
					class=''
					multiple=true
					placeholer='select'
					label='label'
					:options='cityOptions'
					:value='selectedCities'
					:clearable='false'
					@input='handleCityChange'
				)
	br
	br
	br
	br
	Promised(
		:promise='citiesPromise'
	)
		template(v-slot:pending)
			p Loading...
		template(v-slot:rejected='error')
			p Error: {{ error.message }}
		template(v-slot='data')
			.col-sm-12.card
				table.table.table-dark
					tr
						th
						th(v-for='city in cities')
							label {{ city.label.toUpperCase() }}
				table.table.table-dark(v-for='category in categories')
					tr
						th
						th {{ category.label.toUpperCase() }}
					tr(v-for='subcategory in category.subs')
						td {{ subcategory.label.toUpperCase() }}
						td(v-for='city in cities')
							Rating(
								:rating='city.report[category.label][subcategory.label]'
							)
</template>

<script>
import fp from 'lodash/fp'

import mock from '../lib/mock'
import Rating from '../components/Rating'

export default {
	name       : 'Home',
	components: {
		Rating
	},
	data: function() {
		return {
			upperCaseFirstLetter : (string) => {
				const splitted = string.split('')
				splitted[0] = splitted[0].toUpperCase()
				splitted.join('')
			},
			cityOptionsPromise   : null,
			citiesPromise        : null,
			cityOptions          : [],
			allCityOptions       : [],
			cities               : [],
			selectedCities       : [],
			categories           : [],
			subcategories        : []
		}
	},
	created: async function() {
		this.categoriesPromise = this.getCategories()
			.then((categories) => {
				this.categories = categories
			})

		this.cityOptionsPromise = this.getCityOptions()
			.then((cityOptions) => {
				this.cityOptions = cityOptions
				this.allCityOptions = cityOptions
			})
			.then(() => {
				const randomCityLabels = fp.chain(new Array(3))
					.map((_, i) => {
						return fp.random(i, this.cityOptions.length - 1)
					})
					.uniq()
					.map(i => {
						return this.cityOptions[i].label
					})
					.value()

				return this.citiesPromise = this.getCities({
					query: { label: randomCityLabels }
				})
			})
			.then((cities) => {
				this.cities = cities
			})

		try {
			await [ this.categoriesPromise, this.cityOptionsPromise ]
		}
		catch (error) {
			console.error('BAD', error)
		}
	},
	methods: {
		handleCityChange(cities) {
			if(cities.length > 5) return console.warn(`can't select more than 3 cities!`)

			this.cities = cities
			this.selectedCities = cities
			this.cityOptions = this.allCityOptions.filter((option) => {
				return !this.selectedCities.find((city) => {
					return city.label === option.label
				})
			})
		},
		// get only the names and labels
		getCityOptions() {
			return new Promise((resolve, _) => {
				resolve(mock.cityOptions)
			})
		},
		// get the full cities
		getCities({ query }) {
			return new Promise((resolve, _) => {
				const cities = fp.chain(query.label)
					.map((label) => {
						return mock.cities.find((city) => {
							return city.label === label
						})
					})
					.compact()
					.value()

				this.handleCityChange(cities)
				resolve(cities)
			})
		},
		getCategories() {
			return new Promise((resolve, _) => {
				resolve(mock.categories)
			})
		}
	}
}
</script>
